<template>
  <v-row class="ml-3" no-gutters>
    <v-col cols="12" sm="6">
      <p class="subtitle-1 text-color">{{ label }}</p>
    </v-col>
    <v-col cols="12" sm="6">
      <p class="subtitle-1 black--text">{{ value }}</p>
      <div v-if="isPlan">
        <v-btn v-if="modifyPlan" text @click="$emit('open-plan')">
          <v-icon>change_circle</v-icon>
          <span
            class="black--text subtitle-2 font-weight-regular "
            style="font-size: 12px !important;"
            >{{ $t("organization_billing.change_plan") }}</span
          >
        </v-btn>
        <v-btn v-else text @click="$emit('open-plan')">
          <v-icon>change_circle</v-icon>
          <span
            class="black--text subtitle-2 font-weight-regular "
            style="font-size: 12px !important;"
            >{{ $t("organization_billing.activate_plan") }}</span
          >
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    isPlan: { type: Boolean, required: false, default: false },
    modifyPlan: { type: Boolean, required: false, default: false }
  }
};
</script>

<style scoped>
/* Add your styling here */
.text-color {
  color: #2661ff;
}
</style>
